module.exports = __webpack_public_path__ + "img/167010.495865be.jpg";